import React from "react";
import LoadingButton from "../../../../components/LoadingButton/LoadingButton";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import { useTranslation } from "react-i18next";

const LOCALE = "modules_Guests_pages_GuestPaymentPage_PaymentSummary";

interface PaymentSummaryProps {
  totalPrice: number;
  serviceCost: number;
  serviceTax: number;
  finalTotal: number;
  progress: number;
  loading: boolean;
  handlePayment: () => Promise<void>;
  disablePayment: boolean;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  totalPrice,
  serviceCost,
  serviceTax,
  finalTotal,
  progress,
  loading,
  handlePayment,
  disablePayment,
}) => {
  const { t } = useTranslation(LOCALE);

  return (
    <div className="w-full md:w-1/3 bg-primary text-white p-8 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">{t("purchase_summary")}</h2>
      <div className="border-b border-white mb-4 pb-4">
        <div className="grid grid-cols-2 gap-4">
          <span>{t("subtotal")}</span>
          <span className="text-right">
            {totalPrice.toLocaleString("es-MX", {
              style: "currency",
              currency: "MXN",
            })}
          </span>
          <span>{t("service_cost")}</span>
          <span className="text-right">
            {serviceCost.toLocaleString("es-MX", {
              style: "currency",
              currency: "MXN",
            })}
          </span>
          <span>{t("tax", { defaultValue: "IVA" })}</span>
          <span className="text-right">
            {serviceTax.toLocaleString("es-MX", {
              style: "currency",
              currency: "MXN",
            })}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 text-lg font-bold mb-4">
        <span>{t("total")}</span>
        <span className="text-right">
          {finalTotal.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          })}
        </span>
      </div>
      <LoadingButton
        label={t("proceed_to_payment")}
        onClick={handlePayment}
        progress={progress}
        type="primary"
        className="w-full bg-white text-primary"
        disabled={loading || disablePayment}
      />
    </div>
  );
};

export default withTranslations(LOCALE)(PaymentSummary);
